<template>
    <div
    class="container-fluid get-started-section py-5 mt-5"
    data-aos="fade-up"
    data-aos-duration="1800"
  >
    <div class="row h-100 align-items-center py-5">
      <div class="col-md-12 text-center">
        <h1 class="fs-51 aonik-reqular">Get Started with Kinfolk today</h1>
        <p class="aonik-light fs-21">
          Preserve your memories and connect with family
        </p>
        <a class="btn signature-btn mt-3" href="#">Get Started</a>
      </div>
    </div>
  </div>
  <div id="section-footer">
    <footer>
      <div class="container py-5">
        <div class="row py-4">
          <div class="col-md-6">
            <img class="footer-logo" src="../assets/images/logo.png" alt="" />
          </div>
          <Newsletter />
        </div>
        <div class="row py-4 link-box">
          <div class="col-md-2">
            <h5>Company</h5>
            <ul>
              <li><router-link to="/about">About us</router-link></li>
              <li><router-link to="">Pricing</router-link></li>
              <li><router-link to="">Jobs</router-link></li>
            </ul>
          </div>
          <div class="col-md-2">
            <h5>Product</h5>
            <ul>
              <li><router-link to="">Feature</router-link></li>
              <li><router-link to="">Privacy and Security</router-link></li>
              <li><router-link to="">Social impact</router-link></li>
            </ul>
          </div>
          <div class="col-md-2">
            <h5>Help Center</h5>
            <ul>
              <li><router-link to="">Community</router-link></li>
              <li><router-link to="">Support</router-link></li>
            </ul>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-4">
            <h5>Download</h5>
            <ul>
              <li>
                <router-link to=""
                  >Join millions of people finding their true belonging.</router-link
                >
              </li>
              <li class="mobile-app">
                <span>
                  <a class="pe-md-2" href="">
                    <img src="../assets/images/apple-store.png" alt="" />
                  </a>
                </span>
                <span>
                  <router-link to="">
                    <img src="../assets/images/play-store.png" alt="" />
                  </router-link>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div class="row bottom-bar">
          <div class="col-md-6 copyright">
            <p>Copyright (c) 2023 Kinfolk. All Rights Reserved.</p>
          </div>
          <div class="col-md-6">
            <div class="policy-links">
              <router-link to="">Privacy Policy</router-link>
              <router-link to="">Terms</router-link>
              <router-link to="">Cookie Policy</router-link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Newsletter from "./Newsletter.vue";
export default {
  name: "footer",
  components: { Newsletter },
};
</script>

<style>
</style>